import vendor from "fragments/vendors/vendor"
import { gql } from "graphql-tag"

const UPDATE_VENDOR = gql`
  ${vendor}

  mutation updateVendor(
    $id: ID!
    $vendorUpdateInput: VendorUpdateInput!
    $socialLinksUpdateInput: SocialLinksUpdateInput
  ) {
    updateVendor(
      id: $id
      vendorUpdateInput: $vendorUpdateInput
      socialLinksUpdateInput: $socialLinksUpdateInput
    ) {
      ...Vendor
    }
  }
`

export default UPDATE_VENDOR
